import { render, staticRenderFns } from "./DatasetQueryResultsAcquisition.vue?vue&type=template&id=260cb54a&"
import script from "./DatasetQueryResultsAcquisition.vue?vue&type=script&lang=ts&"
export * from "./DatasetQueryResultsAcquisition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports